import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { AsyncPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Car } from 'src/app/public/car/models/car.model';
import { DealerBasicData } from '../../constants/dealer-basic-data';
import { ContractModification } from '../../models/contract-modification.model';
import { MatSelectModule } from '@angular/material/select';


@Component({
    selector: 'app-contract-modification-dialog',
    templateUrl: './contract-modification-dialog.component.html',
    styleUrls: ['./contract-modification-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatDialogModule, MatIconModule, MatProgressSpinnerModule, MatIconModule, MatDividerModule, AsyncPipe, MatSelectModule]
})
export class ContractModificationDialogComponent implements OnInit{

  disabled = false;

  contractBusinessLines = DealerBasicData.contractBusinessLines;

  isNew: boolean = false; 
  isCarSpecific: boolean = false; 

  modification: ContractModification = new ContractModification();
  cars: Car[] = [];

  currentCar: Car = new Car();
  
  constructor(
    public dialogRef: MatDialogRef<ContractModificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {modification: ContractModification, cars: Car[]} ,
    private store: Store,
    private router: Router, 
    private route: ActivatedRoute) {

    }

    ngOnInit(): void {
      this.isNew = (this.data.modification.id === -1);
      this.cars = this.data.cars;
      this.isCarSpecific = (this.data.modification.carId.length > 0);
      console.log(this.data.cars)
      this.currentCar = Object.assign(new Car(), this.data.cars.find(car  => car.carId == this.data.modification.carId) ! );
    } 
  
    onNoClick(): void {
      this.dialogRef.close();
    }


}
